import { useEffect, useState } from 'react';

const useGuestDetailsFormHook = ({ form, values, onFormChange, initialValues }) => {
  const [state, setState] = useState({ validForm: false, initialized: false });

  useEffect(() => {
    if (initialValues) {
      updateState({ validForm: true });
      onFormChange({ ...form.getFieldsValue(), isValid: true });
    }
    updateState({ initialized: true });
  }, []);

  useEffect(() => {
    if (state.initialized) {
      actions.validateForm(form.getFieldsValue());
    }
  }, [values]);

  const actions = {
    validateForm: async fields => {
      try {
        await form.validateFields({ validateOnly: true });
        updateState({ validForm: true });
        onFormChange({ ...fields, isValid: true });
      } catch {
        updateState({ validForm: false });
        onFormChange({ ...fields, isValid: false });
      }
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
};

export default useGuestDetailsFormHook;
